import type { ReactElement } from "react";

import { SocureDeviceRiskProvider } from "./socure";

export function SignerPortalVendorProviders({ children }: { children: ReactElement }) {
  return <SocureDeviceRiskProvider>{children}</SocureDeviceRiskProvider>;
}
